/* Gallery progress bar.

   The theme only moves the bar when it receives a `slideChanged` event, which
   the slider dispatches for thumbnail and arrow navigation. Swiping the images
   with a finger scrolls the track without ever producing that event, so the
   bar sat still while the customer moved through the images.

   Driving it from the track's own scroll position fixes both halves: it moves
   continuously under the thumb rather than stepping, and because hidden slides
   contribute nothing to the scroll width it stays correct with the variant
   filtering, where only two of eighteen slides are showing.

   Deliberately self-contained, and it touches nothing but its own CSS variable
   on the bar element. */
(function () {
  'use strict';
  if (window.__kvpGalleryProgress) return;
  window.__kvpGalleryProgress = true;

  function wire(track) {
    if (track.__kvpProgress) return;
    var bar = document.querySelector('.gallery-progress-bar');
    if (!bar) return;
    track.__kvpProgress = true;

    var desired = null;

    function paint() {
      var max = track.scrollWidth - track.clientWidth;
      var pct;
      if (max <= 1) {
        pct = 100;                                   /* a single slide is the whole story */
      } else {
        pct = ((track.scrollLeft + track.clientWidth) / track.scrollWidth) * 100;
      }
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;
      desired = pct.toFixed(2) + '%';
      bar.style.setProperty('--progress-width', desired);

      /* Keep the announced position in step with what the bar shows. */
      var slides = [].slice.call(track.querySelectorAll('.product__media-item'))
        .filter(function (li) { return li.style.display !== 'none' && li.offsetWidth > 0; });
      if (slides.length) {
        var index = Math.min(slides.length, Math.max(1, Math.round(pct / (100 / slides.length))));
        bar.setAttribute('aria-label', 'Image ' + index + ' of ' + slides.length);
      }
    }

    /* The theme still recalculates the bar from its own idea of the active
       slide whenever the slider fires slideChanged, and with the variant
       filtering that calculation lands on a fixed value, so it stamped over
       the scroll position immediately. Put ours back whenever it does. */
    new MutationObserver(function () {
      if (desired && bar.style.getPropertyValue('--progress-width') !== desired) {
        bar.style.setProperty('--progress-width', desired);
      }
    }).observe(bar, { attributes: true, attributeFilter: ['style'] });

    /* The theme animates the fill over 300ms, which lags behind a finger. */
    bar.style.setProperty('transition', 'none', 'important');
    var fillFix = document.createElement('style');
    fillFix.textContent = '.gallery-progress-bar::after{transition:none !important;}';
    document.head.appendChild(fillFix);

    track.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint, { passive: true });
    /* A variant change re-filters the slides, which changes the scroll width. */
    document.addEventListener('change', function () { setTimeout(paint, 250); }, true);
    setTimeout(paint, 100);
    setTimeout(paint, 900);
    paint();
  }

  function boot(n) {
    var track = document.querySelector('.product__media-list');
    if (track && document.querySelector('.gallery-progress-bar')) { wire(track); return; }
    if (n < 25) setTimeout(function () { boot(n + 1); }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); });
  else boot(0);
})();

/* Klaviyo welcome pop-up (Oct 2026), separate from the gallery code above.
   Once a visitor has signed up, the MYSTERY OFFER tab must not appear again,
   including on the same page if they close the pop-up at the text step.
   Klaviyo already hides the pop-up and its tab from known subscribers on later
   pages; this covers the page where they signed up. A visitor counts as signed
   up once Klaviyo has identified them, which happens when they enter their
   email. All this does is add a class to <html>; custom_css.css uses it to
   hide the tab. */
(function () {
  'use strict';
  if (window.__kaTeaserGuard) return;
  window.__kaTeaserGuard = true;

  var CLS = 'ka-signed-up';
  var root = document.documentElement;

  function known() { return root.classList.contains(CLS); }
  function mark() { root.classList.add(CLS); }

  function fromCookie() {
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return false;
    try {
      var o = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(o && (o.$exchange_id || o.$email || o.$phone_number));
    } catch (e) { return false; }
  }

  function check() {
    if (known()) return;
    if (fromCookie()) { mark(); return; }
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') {
      try {
        var p = k.isIdentified();
        if (p && typeof p.then === 'function') p.then(function (yes) { if (yes) mark(); }, function () {});
      } catch (e) {}
    }
  }

  check();
  var timer = setInterval(function () {
    check();
    if (known()) clearInterval(timer);
  }, 2000);

  /* Klaviyo announces form activity on window; check straight after a submit. */
  window.addEventListener('klaviyoForms', function (e) {
    var t = e && e.detail && e.detail.type;
    if (t === 'submit' || t === 'stepSubmit' || t === 'close') {
      setTimeout(check, 400);
      setTimeout(check, 1500);
    }
  });
})();
